<script>
  export let battleScreenSmall = false;

  import { onMount } from "svelte";
  import SpinNumber from "../components/SpinNumber.svelte";
  import { fade } from "svelte/transition";
  import {
    CurrentBattleLog,
    CurrentStateName,
    Hearts,
    IsTurn,
    PlayerId,
    SetupStore,
    GameStateStore,
    PotionsStore,
  } from "../stores/gameStore";
  import ComponentTiled from "../components/ComponentTiled.svelte";
  import { SPRITES, TYPE_SPRITE_MAP } from "../../constants/sprites";
  import Component from "../components/Component.svelte";
  import PotionCard from "../components/PotionCard.svelte";
  import DieSingle from "../components/DieSingle.svelte";
  import {
    getTextsPlayerboards,
    getTextsKings
  } from "../../constants/allTexts";

  let updateSpinPlayer = 0;
  let updateSpinEnemy = 0;

  $: playerDice = $CurrentBattleLog?.player?.dice || { D6: [], D12: [] };
  $: enemyDice = $CurrentBattleLog?.enemy?.dice || { D6: [], D12: [] };

  function resetPlayerRolled() {
    // Update values to false
    playerRolled.D6 = playerRolled.D6.map(() => false);
    playerRolled.D12 = playerRolled.D12.map(() => false);
  }

  let playerRolled = { D6: [], D12: [] };
  let enemyRolled = { D6: [], D12: [] };
  let triggerReactivityPlayer = 1;
  let triggerReactivityEnemy = 1;
  let amountRolledDice = 0;
  let amountPlayerD6 = 0;
  let amountPlayerD12 = 0;
  let amountEnemyD6 = 0;
  let amountEnemyD12 = 0;
  $: if (triggerReactivityPlayer != $CurrentBattleLog?.player?.rolledDice?.triggerReactivity || triggerReactivityEnemy != $CurrentBattleLog?.enemy?.rolledDice?.triggerReactivity) {
    triggerReactivityPlayer = $CurrentBattleLog?.player?.rolledDice?.triggerReactivity;
    triggerReactivityEnemy = $CurrentBattleLog?.enemy?.rolledDice?.triggerReactivity;
    playerRolled = {
      D6: Array.isArray($CurrentBattleLog?.player?.rolledDice?.D6) ? $CurrentBattleLog.player.rolledDice.D6 : [],
      D12: Array.isArray($CurrentBattleLog?.player?.rolledDice?.D12) ? $CurrentBattleLog.player.rolledDice.D12 : []
    };
    enemyRolled = {
      D6: Array.isArray($CurrentBattleLog?.enemy?.rolledDice?.D6) ? $CurrentBattleLog.enemy.rolledDice.D6 : [],
      D12: Array.isArray($CurrentBattleLog?.enemy?.rolledDice?.D12) ? $CurrentBattleLog.enemy.rolledDice.D12 : []
    };
    //get rolled dice amount for sound
    amountPlayerD6 = playerRolled.D6.filter(value => value === true).length || 0;
    amountPlayerD12 = playerRolled.D12.filter(value => value === true).length || 0;
    amountEnemyD6 = enemyRolled.D6.filter(value => value === true).length || 0;
    amountEnemyD12 = enemyRolled.D12.filter(value => value === true).length || 0;
    amountRolledDice = amountPlayerD6 + amountPlayerD12 + amountEnemyD6 + amountEnemyD12;
    if (amountRolledDice == 1) {
      playSound('Kingscraft_diceSmall');
    }
    if (amountRolledDice > 1 && amountRolledDice < 4) {
      playSound('Kingscraft_diceMid');
    }
    if (amountRolledDice > 3) {
      playSound('Kingscraft_diceBig');
    }
    setTimeout(() => {
      resetPlayerRolled();
        }, 200);
  }
  $: playerRolled = $CurrentBattleLog?.player?.rolledDice || { D6: [], D12: [] };
  $: enemyRolled = $CurrentBattleLog?.enemy?.rolledDice || { D6: [], D12: [] };

  const bgs = ["class1", "class2", "class3"];

  $: enemyCard = $CurrentBattleLog?.enemy?.enemyID
    ? $SetupStore?.data?.cards[$CurrentBattleLog?.enemy?.enemyID]
    : undefined;
  $: bgClass = !enemyCard
    ? ""
    : enemyCard.type === "KING"
      ? "classK"
      : bgs[enemyCard.level - 1];

  $: potions = Object.values($PotionsStore).filter((c) => c.card_location == $GameStateStore.active_player);

  $: playerDiceScore = (Math.max(0, $CurrentBattleLog?.player?.totalStrength - $CurrentBattleLog?.player?.baseStrength)) || 0;
  $: if (playerDiceScore !== 0) {
      updateSpinPlayer++
    }

  $: enemyDiceScore = (Math.max(0, $CurrentBattleLog?.enemy?.totalStrength - $CurrentBattleLog?.enemy?.baseStrength  - $CurrentBattleLog?.enemy?.guardBonus)) || 0;
  $: if (enemyDiceScore !== 0) {
      updateSpinEnemy++
    }

  $: playerItemScore = $CurrentBattleLog?.player?.baseStrength || 0;
  $: enemyItemScore = $CurrentBattleLog?.enemy?.baseStrength || 0;
  $: enemyGuardBonus = $CurrentBattleLog?.enemy?.guardBonus || 0;

  $: playerTotal = $CurrentBattleLog?.player?.totalStrength || 0;
  $: enemyTotal = $CurrentBattleLog?.enemy?.totalStrength || 0;

  $: restriction = $CurrentBattleLog?.enemy?.restriction || 0;

  $: armor = $CurrentBattleLog && $CurrentBattleLog.player && $CurrentBattleLog.player.armor
    ? $CurrentBattleLog.player.armor
    : 0;
  $: extraDamage = $CurrentBattleLog?.enemy?.extraDamage || 0;

  let autoRerolls = false;
  let autoRerollSprite = false;
  $: if ($CurrentBattleLog?.player?.autoRerolls?.length > 0) {
        if ($CurrentBattleLog?.player?.autoRerolls?.includes(1)) {
          autoRerolls = true;
          autoRerollSprite = 'REROLL_1s';
        }
        if ($CurrentBattleLog?.player?.autoRerolls?.includes(2)) {
          autoRerolls = true;
          autoRerollSprite = 'REROLL_2s';
        }
        if ($CurrentBattleLog?.player?.autoRerolls?.includes(3)) {
          autoRerolls = true;
          autoRerollSprite = 'REROLL_3s';
        }
    }

  let autoRerollsEnemy = false;
  let autoRerollSpriteEnemy = false;
  $: if ($CurrentBattleLog?.enemy?.autoRerollsD6?.length > 0) {
        if ($CurrentBattleLog?.enemy?.autoRerollsD6?.includes(6)) {
          autoRerollsEnemy = true;
          autoRerollSpriteEnemy = 'ENEMY_REROLL_6s';
        }
        if ($CurrentBattleLog?.enemy?.autoRerollsD6?.includes(5)) {
          autoRerollsEnemy = true;
          autoRerollSpriteEnemy = 'ENEMY_REROLL_5s';
        }
    }

  $: result = $CurrentBattleLog?.result;
  let updateResult = result;
  $: if (updateResult != result) {
    updateResult = result;
    if (result == 'WIN') {
      setTimeout(() => {
        playSound('Kingscraft_win');
        }, 100);
    }
    if (result == 'LOOSE') {
      setTimeout(() => {
        playSound('Kingscraft_loose');
        }, 500);
    }
    // if (result == 'RESTART') {
    //   setTimeout(() => {
    //     playSound('Kingscraft_restart');
    //     }, 200);
    // }
  }

  $: heartsLost = $CurrentBattleLog?.lostHearts || 0;
  $: hearts = ($Hearts?.[$PlayerId] || 0) - heartsLost;
  let maxHearts = 3;
  $: $CurrentBattleLog?.player?.characterID != "IRONCLAD_SPEC"
    ? maxHearts = 3
    : maxHearts = 4;
  $: currentHearts = $CurrentBattleLog?.player?.currentHearts || 0;  

  $: timeForReroll =
    IsTurn &&
    $CurrentBattleLog?.player?.rerolls > 0 &&
    $CurrentBattleLog?.timeForReroll;

  let statusBarReroll = false;  
  $: if (timeForReroll && statusBarReroll == false) {
    statusBarReroll = true;
    const textMustReroll = $IsTurn ? _('${you} must reroll a die or pass') : _('${actplayer} must reroll a die or pass');
    window.GAME.statusBar.setTitle(textMustReroll, '');
  }
  $: if (!timeForReroll && statusBarReroll == true) {
    statusBarReroll = false;
    window.GAME.updatePageTitle();
  }

  let statusBarResult = false;  
  $: if (result && statusBarResult == false) {
    statusBarResult = true;
    const textMustFinish1 = _('${you} must finish the fight');
    const textMustFinish2 = _('${actplayer} must finish the fight');
    const textMustFinish3 = _('${you} must restart the fight or finish it');
    const textMustFinish4 = _('${actplayer} must restart the fight or finish it');
    const textMustFinish5 = _('${you} must use a potion or finish the fight');
    const textMustFinish6 = _('${actplayer} must use a potion or finish the fight');
    const textMustFinish7 = _('${you} must use a potion, restart the fight or finish it');
    const textMustFinish8 = _('${actplayer} must use a potion, restart the fight or finish it');
    let chosenText = $IsTurn ? textMustFinish1 : textMustFinish2;
    if ($CurrentBattleLog?.player?.restartFight > 0) {
      chosenText = $IsTurn ? textMustFinish3 : textMustFinish4;
    }
    if (potions.length > 0) {
      chosenText = $IsTurn ? textMustFinish5 : textMustFinish6;
    }
    if (potions.length > 0 && $CurrentBattleLog?.player?.restartFight > 0) {
      chosenText = $IsTurn ? textMustFinish7 : textMustFinish8;
    }
    window.GAME.statusBar.setTitle(chosenText, '');
  }
  $: if (!result && statusBarResult == true) {
    statusBarResult = false;
    window.GAME.updatePageTitle();
  }

  // Reactive calculation whenever dice or screen size changes
  let playerDiceCount = 0;
  let enemyDiceCount = 0;
  let maxDiceCount = 0;
  let totalHeight = 0;

  $: {
    const playerDice = $CurrentBattleLog?.player?.dice || { D6: [], D12: [] };
    const enemyDice = $CurrentBattleLog?.enemy?.dice || { D6: [], D12: [] };

    playerDiceCount = (playerDice.D6.length || 0) + (playerDice.D12.length || 0);
    enemyDiceCount = (enemyDice.D6.length || 0) + (enemyDice.D12.length || 0);

    // Determine the maximum dice count between the two
    maxDiceCount = Math.max(playerDiceCount, enemyDiceCount);

    // Calculate the number of rows based on the screen size
    const dicePerRow = battleScreenSmall ? 3 : 5;
    const numberOfRows = Math.ceil(maxDiceCount / dicePerRow);

    // Set the total height based on number of rows
    const rowHeight = 75; // Height per row in pixels
    totalHeight = numberOfRows * rowHeight;
  }

  onMount(() => {
    window.GAME.addTooltipHtml(
      "reroll",
      `${$SetupStore.data.skillInfo.skills["REROLL"].description}}`
    );
  });

  const textPlayer = _('Player');
  const textEnemy = _('Enemy');
  const textBasestrength = _('Basestrength');
  const textTotal = _('Total');
  const textCurrentHearts = _('Current hearts');
  const textHeartLoss = _('Heart loss');
  const textHeartLost = _('Heart lost');
  const textHeartsLost = _('Hearts lost');
  const textWin = _('WIN');
  const textLose = _('LOSE');
  const textRestart = _('RESTART');
  const textRestartSmall = _('Restart Fight');
  const textPass = _('Pass');
  const textClickDice = _('Click dice to reroll or pass.');
  const textFinish = _('Finish');
  const textDamageCalculation = _('Damage Calculation');
  const textEnemyTotal = _('Enemy Total');
  const textExtraDamage = _('Extra Damage');
  const textArmor = _('Armor');
  const textTotalDamage = _('Total Damage');
  const textsPlayerboards = getTextsPlayerboards();
  const textsKings = getTextsKings();
  $: textCharacterName = textsPlayerboards[$CurrentBattleLog?.player?.characterID].name;
  let textEnemyName = _('Creature');
  $: if ($CurrentBattleLog?.enemy?.class == 4) {
    textEnemyName = textsKings[$CurrentBattleLog?.enemy?.enemyID].type;
  }

  //Tooltip for damage-Info
  function updateTooltip() {
    window.GAME.addTooltipHtml(
      "damageinfo_id",
      `<div style="display:flex; flex-direction:column; max-width: 450px; word-wrap: break-word;">
        <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
          <div class="headline">
            ${textDamageCalculation}
          </div>
        </div>
        <hr style="width:100%;"/>
        <p>${textEnemyTotal} (${enemyTotal}) + ${textExtraDamage} (${extraDamage}) - ${textArmor} (${armor})</p>
        <p>= ${textTotalDamage}: ${Math.max(0, (enemyTotal + extraDamage - armor))}</p>
        <hr style="width:100%;"/>
        <p>0 ${textTotalDamage}: 0 ${textHeartsLost}</p>
        <p>1-10 ${textTotalDamage}: 1 ${textHeartLost}</p>
        <p>11-20 ${textTotalDamage}: 2 ${textHeartsLost}</p>
        <p>21-30 ${textTotalDamage}: 3 ${textHeartsLost}</p>
        <p>31-40 ${textTotalDamage}: 4 ${textHeartsLost}</p>
      </div>`
    );
  }

  onMount(() => {
    updateTooltip();
  });

  $: if (enemyTotal || extraDamage || armor) {
    updateTooltip(); // Re-run tooltip creation when enemyTotal, extraDamage, or armor changes
  }

</script>

<pre>{JSON.stringify(potions.length > 0, null, 2)}</pre>

  <div class="wrapper" transition:fade>
    <div
    class="container"
    style="width: {battleScreenSmall ? 33 : 54}rem"
    >
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div class={`scene ${bgClass}`}>
        <!-- WIN/LOSE -->
        {#if result == "WIN"}
          <div class="headline result win" in:fade={{ delay: 1000 }}>{textWin}</div>
        {/if}
        {#if result == "LOOSE"}
          <div class="headline result lose" in:fade={{ delay: 1000 }}>{textLose}</div>
        {/if}
        {#if result == "RESTART"}
          <div class="headline result restart" in:fade={{ delay: 200 }}>{textRestart}</div>
        {/if}

        <!-- PLAYER IMG -->
        {#if $CurrentBattleLog?.player?.characterID}
          <ComponentTiled
            width={200}
            sprite={SPRITES[TYPE_SPRITE_MAP["AVATAR"]]}
            offset={$SetupStore.data.playerBoards[
              $CurrentBattleLog.player.characterID
            ]?.fightSprite}
            style={`filter:${hearts <= 0 ? "sepia(1)" : result === "LOSE" ? "contrast(.7) brightness(0.5) sepia(1) hue-rotate(318deg) saturate(4)" : ""}; `}
          />
        {/if}

        <!-- MONSTER IMG -->
        <!-- drop-shadow(0px 0px 6px black) -->
        {#if $CurrentBattleLog?.enemy?.enemyID}
          <ComponentTiled
            width={200}
            sprite={SPRITES[TYPE_SPRITE_MAP["AVATAR"]]}
            offset={$SetupStore.data.cards[$CurrentBattleLog.enemy.enemyID]
              ?.fightSprite}
            style={`filter:${result === "WIN" ? "contrast(.7) brightness(0.5) sepia(1) hue-rotate(318deg) saturate(4)" : ""};`}
          />
        {/if}
      </div>
      
      <div style="display:flex; flex:1;">
        <div class="box">
          <div class="itemsRow" style="height: 62px;">
            <div class="headline" style="font-size:4rem;">
              {textCharacterName}
            </div>

            <!-- POTIONS -->
            <div style="display:flex; gap:.5rem; align-items:center">
              {#each potions as card}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                class="potion"
                on:click|stopPropagation|preventDefault={() => { 
                  window.GAME.bgaPerformAction("usePotion", {
                    cardId: card.id,
                    playerId: $PlayerId
                  });
                }}>
                  <PotionCard
                    width={36}
                    card={$SetupStore.data.cards[card.id]}
                    id={card.id}
                    active={card.active}
                  />
                </div>
              {/each}
            </div>
          </div>
          <hr height="1px" width="100%" />
          <!--  PLAYER -->
          <div style="display:flex; flex-direction:column; flex-wrap: wrap;">
            <div
            class= "dice-container"
            style="height: {totalHeight}px"
            >
              <!-- svelte-ignore a11y-no-static-element-interactions -->
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              {#each playerDice['D6'] as die, i}

                <div
                style="width: 75px; height: 75px; transform: scale(0.75); transform-origin: top left;"
                >
                  <DieSingle
                    sides = {6}
                    result = {die}
                    rolling = {playerRolled.D6[i]}
                    index = {i}
                    who = 'player'
                    timeForReroll = {timeForReroll}
                  />
                </div>
              {/each}
              {#each playerDice['D12'] as die, i}
                <div style="width: 75px; height: 75px; transform: scale(0.75); transform-origin: top left;">
                  <DieSingle
                    sides = 12
                    result = {die}
                    rolling = {playerRolled.D12[i]}
                    index = {i}
                    who = 'player'
                    timeForReroll = {timeForReroll}
                  />
                </div>
              {/each}
            </div>

            <div
              style="display:flex; justify-content:space-between; align-Items:center; gap:1rem;"
            >
              <div
               style={battleScreenSmall
               ? "display:flex; flex-direction: column; justify-content: flex-end; height: 128px"
               : "display:flex; flex-direction: row; gap:1rem"
               }
              >
                <button
                  class="btn"
                  class:disabled={!timeForReroll || !$IsTurn}
                  on:click={() => {
                    window.GAME.bgaPerformAction("fightPlayerFinished");
                  }}
                >
                  {textPass}
                </button>

                <div style="display:flex; align-items:center; gap:.5rem;">
                  <Component
                    width={30}
                    sprite={{
                      width:
                        $SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                          ?.size[0] || 0,
                      height:
                        $SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                          ?.size[1] || 0,
                      class: "SKILLS",
                    }}
                    fullWidth={SPRITES.SKILLS.fullWidth}
                    offset={$SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                      ?.offset || [0, 0]}
                  />

                  <span class="headline" style="font-size:2.5rem;">
                    {$CurrentBattleLog?.player?.rerolls}{'/'}{$CurrentBattleLog?.player?.rerollsMax}
                  </span>
                </div>

                {#if autoRerolls}
                  <div style="display:flex; align-items:center; gap:.5rem;">
                    <Component
                      width={72}
                      sprite={{
                        width:
                          $SetupStore?.data?.skillInfo?.skills?.[autoRerollSprite]
                            ?.size[0] || 0,
                        height:
                          $SetupStore?.data?.skillInfo?.skills?.[autoRerollSprite]
                            ?.size[1] || 0,
                        class: "SKILLS",
                      }}
                      fullWidth={SPRITES.SKILLS.fullWidth}
                      offset={$SetupStore?.data?.skillInfo?.skills?.[autoRerollSprite]
                        ?.offset || [0, 0]}
                    />
                  </div>
                {/if}
              </div>

              <div style="flex:1" />

              <div
                class="headline"
                style="font-size:4rem; align-self:flex-end;"
                in:fade={{ delay: 400 }}
              >
                +<SpinNumber
                  value={playerDiceScore}
                  duration={800}
                  update={updateSpinPlayer}
                />
              </div>
            </div>
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:4rem">{textBasestrength}</div>
            <div class="headline" style="font-size:4rem">
              +{playerItemScore}
            </div>
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:6rem">{textTotal}</div>
            {#if !!result}
              <div
                class="headline"
                style="font-size:6rem"
                in:fade={{ delay: 500 }}
              >
                {playerTotal}
              </div>
            {/if}
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:4rem">{textArmor}</div>
              <div class="headline" style="font-size:4rem">
                {armor}
              </div>
            </div>
          <hr height="1px" width="100%" />
          <div
          class="itemsRow"
          style={battleScreenSmall
            ? "display:block"
            : ""
            }
          >
            <div class="headline" style="font-size:4rem">{textCurrentHearts}</div>
            <div
            class="hearts"
            >
              {#each Array(maxHearts).fill(0) as heart, i}
                  <ComponentTiled
                  width={45}
                  sprite={SPRITES["TOKENS"]}
                  borderRadius={1}
                  offset={i < currentHearts
                    ? $SetupStore.data.gameTokens.HEART.offset
                    : $SetupStore.data.gameTokens.HEART.offset_back}
                  className="shadow-sm"
                />
              {/each}
            </div>
          </div>
        </div>
        <div class="divider"></div>

        <div class="box enemy">
          <div class="itemsRow" style="height: 62px;">
            <div class="headline" style="font-size:4rem;">
              {textEnemyName}
            </div>
            {#if  restriction != 0}
              <div style="display:flex; align-items:center; gap:.5rem;">
                <Component
                  width={60}
                  sprite={{
                    width:
                      $SetupStore?.data?.skillInfo?.restriction[restriction]
                        ?.size[0] || 0,
                    height:
                      $SetupStore?.data?.skillInfo?.restriction[restriction]
                        ?.size[1] || 0,
                    class: "SKILLS",
                  }}
                  fullWidth={SPRITES.SKILLS.fullWidth}
                  offset={$SetupStore?.data?.skillInfo?.restriction[restriction]
                    ?.offset || [0, 0]}
                />
              </div>
            {/if}
          </div>
          <hr height="1px" width="100%" />
          <div style="display:flex; flex-direction:column; width:100%;">
            <div
            class= "dice-container enemy-dice"
            style="height: {totalHeight}px"
            >
              {#each enemyDice['D6'] as die, i}
                <div style="width: 75px; height: 75px; transform: scale(0.75); transform-origin: top left;">
                  <DieSingle
                    sides = {6}
                    result = {die}
                    rolling = {enemyRolled.D6[i]}
                    index = {i}
                    who = 'enemy'
                    timeForReroll = {timeForReroll}
                  />
                </div>
              {/each}
              {#each enemyDice['D12'] as die, i}
                <div style="width: 75px; height: 75px; transform: scale(0.75); transform-origin: top left;">
                  <DieSingle
                    sides = 12
                    result = {die}
                    rolling = {enemyRolled.D12[i]}
                    index = {i}
                    who = 'enemy'
                    timeForReroll = {timeForReroll}
                  />
                </div>
              {/each}
            </div>
            <div
              style="display:flex; justify-content:space-between; align-Items:center;"
            >
              <div
                class="headline"
                style="font-size:4rem; align-self:flex-end;"
                in:fade={{ delay: 400 }}
              >
                +<SpinNumber
                  value={enemyDiceScore}
                  duration={800}
                  update={updateSpinEnemy}
                />
              </div>

              <div
                style={battleScreenSmall
                      ? "display:flex; flex-direction: column; justify-content: flex-end; align-items: flex-end; row-gap: 10px; height: 128px"
                      : "display:flex; flex-direction: row; gap: 1rem; height:68px;"
                      }
              >
                {#if autoRerollsEnemy}
                  <div
                  style="display:flex; align-items:center; gap:.5rem; "
                  >
                    <Component
                      width={92}
                      sprite={{
                        width:
                          $SetupStore?.data?.skillInfo?.skills?.[autoRerollSpriteEnemy]
                            ?.size[0] || 0,
                        height:
                          $SetupStore?.data?.skillInfo?.skills?.[autoRerollSpriteEnemy]
                            ?.size[1] || 0,
                        class: "SKILLS",
                      }}
                      fullWidth={SPRITES.SKILLS.fullWidth}
                      offset={$SetupStore?.data?.skillInfo?.skills?.[autoRerollSpriteEnemy]
                        ?.offset || [0, 0]}
                    />
                  </div>
                {/if}

                <div style="display:flex; align-items:center; gap:.5rem; ">
                  <Component
                    width={30}
                    sprite={{
                      width:
                        $SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                          ?.size[0] || 0,
                      height:
                        $SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                          ?.size[1] || 0,
                      class: "SKILLS",
                    }}
                    fullWidth={SPRITES.SKILLS.fullWidth}
                    offset={$SetupStore?.data?.skillInfo?.skills?.["REROLL"]
                      ?.offset || [0, 0]}
                  />
                  <span class="headline" style="font-size:2.5rem;">
                    {$CurrentBattleLog?.enemy?.rerolls}{'/'}{$CurrentBattleLog?.enemy?.rerollsMax}
                  </span>
                </div>

              </div>
            </div>
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:4rem">{textBasestrength}</div>
            {#if enemyGuardBonus == 0}
              <div class="headline" style="font-size:4rem">
                +{enemyItemScore}
              </div>
            {:else}
              <div class="headline" style="font-size:4rem">
                +{enemyItemScore}{"(+"}{enemyGuardBonus}{")"}
              </div>
            {/if}
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:6rem">{textTotal}</div>
            {#if !!result}
              <div
                class="headline"
                style="font-size:6rem; color: {enemyTotal >= playerTotal ? 'red' : 'black'}"
                in:fade={{ delay: 500 }}
              >
                {enemyTotal}
              </div>
            {/if}
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div class="headline" style="font-size:4rem">{textExtraDamage}</div>
              <div class="headline" style="font-size:4rem">
                +{extraDamage}
              </div>
          </div>
          <hr height="1px" width="100%" />
          <div class="itemsRow">
            <div
            style= "display: flex; flex-wrap: wrap; align-items: center; gap: 1rem"
            >
              <div
              class= "damageinfo"
              id= "damageinfo_id"
              >
                <Component
                width={30}
                sprite={{
                  width:
                    $SetupStore?.data?.skillInfo?.skills?.['EXTRADAMAGE']
                      ?.size[0] || 0,
                  height:
                    $SetupStore?.data?.skillInfo?.skills?.['EXTRADAMAGE']
                      ?.size[1] || 0,
                  class: "SKILLS",
                }}
                fullWidth={SPRITES.SKILLS.fullWidth}
                offset={$SetupStore?.data?.skillInfo?.skills?.['EXTRADAMAGE']
                  ?.offset || [0, 0]}
                borderRadius={1}
                className="shadow-sm"
                />
              </div>

              <div class="headline" style="font-size:4rem">
                {textHeartLoss}
              </div>
            </div>

            {#if !!result}
              <div
                class="headline"
                style="font-size:4rem; color: {heartsLost >= currentHearts ? 'red' : 'black'}"
                in:fade={{ delay: 500 }}
              >
                -{heartsLost}
              </div>
            {/if}
          </div>
        </div>
      </div>
      <div class="footer">
        {#if $IsTurn}
          {#if timeForReroll}
            <div
              style={`font-family: "Bigelow Rules", serif;
                    font-size: 3rem;
                    padding: 0 1rem;
                    font-weight: 600;
                    letter-spacing: 1.5chr;
                    transform: scale(1, 0.6);`}
            >
              {textClickDice}
            </div>
          {:else}
            {#if ($CurrentBattleLog?.player?.restartFight || 0) > 0 && $CurrentBattleLog?.result}
              <button
                class="btn"
                style="width:13rem;"
                on:click={() => {
                  window.GAME.bgaPerformAction("reStartFightPlayer");
                }}
                >{textRestartSmall} ({$CurrentBattleLog.player.restartFight})</button
              >
            {/if}
            <button
              class="btn"
              style="width:10rem;"
              disabled={!$CurrentBattleLog?.playerFinished}
              on:click={() => {
                window.GAME.bgaPerformAction("endFight");
              }}>{textFinish}</button
            >
          {/if}
        {/if}
      </div>
    </div>
  </div>

<style>
  .wrapper {
    position: absolute;
    top: 7rem;
    z-index: 90;
    max-width: 1000px;
    justify-content: center;
    transform: translate(-1rem, 0);
    filter: drop-shadow(0px 20px 20px #000000);
  }
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 100%;
    max-width: 1000px;
    background-image: url("img/parchment.png");
    background-size: 100% 100%;
    padding: 1rem;
  }

  .dice-container {
    display: flex;
    flex-wrap: wrap;  /* Allow the dice to wrap to new lines */
    justify-content: flex-start;
    align-content: flex-start;
  }

  .dice-container.enemy-dice {
    justify-content: flex-end;
  }

  .divider {
    margin: 0 -1px;
    width: 1px;
    background: black;
  }

  .box {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
  }

  .enemy {
    align-items: flex-end;
    background: rgba(255, 0, 0, 0.1);
    box-shadow: 7px 0px 10px 5px rgba(255, 0, 0, 0.1);
  }
  .enemy > .itemsRow {
    flex-direction: row-reverse;
  }

  .itemsRow {
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: 0.5rem;
  }

  .skill {
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .scene {
    position: relative;
    width: calc(100% - 0rem);
    height: 16rem;
    background-size: 100% 100%;
    padding: 2rem 0;
    background-position: bottom;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    mix-blend-mode: darken;
    box-shadow: inset 0px 0px 20px 21px #ffebd4;
  }

  .class1 {
    background-image: url("img/bg_class1.jpg");
  }
  .class2 {
    background-image: url("img/bg_class2.jpg");
  }
  .class3 {
    background-image: url("img/bg_class3.jpg");
  }

  .classK {
    background-image: url("img/bg_classK.jpg");
  }

  hr {
    border: none;
    background: black;
    height: 1px;
    width: 100%;
  }
  .footer {
    padding-top: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }

  .result {
    position: absolute;
    left: 50%;
    top: 50%;
    font-size: 8rem;
    margin: 0;
    letter-spacing: 0.8rem;
    text-shadow:
      3px 3px 0 #000,
      -3px 3px 0 #000,
      -3px -3px 0 #000,
      3px -3px 0 #000,
      0px 0px 10px #000;
    transform: translate(-50%, -50%);
  }

  .win {
    color: greenyellow;
  }
  .lose {
    color: red;
  }

  .restart {
    color: rgb(255, 187, 0);
  }

  .hearts {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap:.3rem;
  }

  .damageinfo {
    background: rgba(255, 0, 0, 0.2);
    border-radius: 1rem;
  }

  .damageinfo:hover {
    filter: brightness(1.2);
  }

  .disabled {
    opacity: 0.2;
    pointer-events: none;
  }

  .hideBtn {
    position: absolute;
    top: 1%;
    right: 0;
    cursor: pointer;
  }

  .potion {
    cursor: pointer;
    &:hover {
      filter: brightness(1.2);
    }
  }
</style>
